export default function CTASection() {
  return (
    <div className="bg-gradient-to-b from-teal-50 to-white py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center">
          コインランドリー経営専門スタッフにご相談ください!
        </h2>
        <div className="flex flex-col md:flex-row gap-4 justify-center mb-6">
          <a
            href="tel:08025278110"
            className="flex items-center justify-center gap-3 bg-blue-500 text-white px-8 py-4 rounded-lg font-bold whitespace-nowrap no-underline"
          >
            <i className="ri-phone-fill text-2xl"></i>
            <span>080-2527-8110</span>
          </a>
          <a
            href="https://www.laundrysite.jp/contact.html"
            className="flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-bold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-fill text-2xl"></i>
            <span>お問い合わせフォームはこちら</span>
          </a>
        </div>
        <p className="text-xs text-gray-600 text-center leading-relaxed">
          ※立地等によってはお受けできない場合もございます。<br />
          ※建物解体、アスファルト舗装、外溝、固定資産税などの租税公課や町内会費はオーナーさま(土地所有者様)のご負担となります。
        </p>
      </div>
    </div>
  );
}
